import React, { PureComponent, createRef } from 'react';
import PropTypes from 'prop-types';
import Translator from 'translator';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { FHEContainer, FHETitle, FHEStepper } from 'data/components';
import { Toastr, tools } from 'data/common';
import renderEnvComponent from 'data/common/renderEnvComponent';

import { SvgHome } from 'data/common/iconsvg';
import getSelectors from './selectors';
import Step1 from './components/stepper/Step1';
import Step2 from './components/stepper/Step2';
import Step3 from './components/stepper/Step3';
import { addHome, emailExists } from '../../data/Homes/actions';

class HomeAdd extends PureComponent {
    static propTypes = {
        profile: PropTypes.object.isRequired,
        history: PropTypes.object.isRequired,
        addHome: PropTypes.func.isRequired,
        emailExists: PropTypes.func.isRequired
    };

    constructor(props) {
        super(props);
        this.stepper = createRef();
        this.state = {
            homeForm: { boxMac: '', label: '' },
            userForm: {},
            error: '',
            boxId: ''
        };
    }

    setMacAddress = (macAddress, id) => {
        this.setState(prevState => ({ homeForm: { ...prevState.homeForm, boxMac: macAddress }, boxId: id }));
        this.stepper.current.handleComplete();
    };

    setUser = user => {
        this.setState(prevState => ({ userForm: user, homeForm: { ...prevState.homeForm, label: `${user.firstname} ${user.lastname}` } }));
        this.stepper.current.handleComplete();
    };

    saveHome = homeForm => {
        const { userForm } = this.state;
        const { addHome, profile, history } = this.props;

        const form = { home: homeForm };
        if (this.userExists()) form.user = userForm;

        this.setState({
            error: ''
        });

        return addHome(form)
            .then(({ homeId, success }) => {
                if (success) {
                    Toastr.success(Translator.translate('generic.home.actions.addHomeSuccess', homeForm.label));
                } else {
                    Toastr.warning(Translator.translate('generic.home.actions.addHomePartialError', homeForm.label));
                }
                if (profile.get('admin') || profile.getIn(['user_rights', history.environment], []).includes('homeDetails')) {
                    return history.push(`detail/${homeId.toString()}#details`);
                }
                return history.push('home');
            })
            .catch(error => {
                this.setState({
                    error
                });

                throw error;
            });
    };

    handleUser = user => {
        const { emailExists, history } = this.props;
        this.setState({
            error: ''
        });

        return emailExists(user.email)
            .then(() => this.setUser(user))
            .catch(error => {
                this.setState({
                    error: 'user'
                });
                Toastr.error(Translator.translate(`generic.resident.actions.add.error`, user.lastname, user.firstname));
                throw error;
            });
    };

    getSteps = () => {
        const { homeForm, userForm, error, boxId } = this.state;
        const { history } = this.props;
        const macAddress = homeForm.boxMac ? homeForm.boxMac.match(/.{1,2}/g).join(':') : '';
        const userName = this.userExists() ? `${userForm.firstname} ${userForm.lastname}` : null;

        return [
            {
                label: [
                    Translator.translate(`generic.home.boxChoice`, Translator.translate(`${history.environment}.centerName`)),
                    <br key="br" />,
                    macAddress === '' ? '' : `${Translator.translate('general.table.column.macAddress')}: ${macAddress} ( ID: ${boxId} )`
                ],
                optional: true,
                component: <Step1 setMacAddress={this.setMacAddress} boxMac={homeForm.boxMac} />,
                error: error === 'mac'
            },
            {
                label: `${Translator.translate('generic.resident.table.title', userName ? userName : '')}`,
                optional: true,
                component: <Step2 handleUser={this.handleUser} userForm={userForm} />,
                error: error === 'user'
            },
            {
                label: Translator.translate('general.home'),
                component: <Step3 homeForm={homeForm} passRef={this.test} saveHome={this.saveHome} />,
                error: error === 'home'
            }
        ];
    };

    userExists() {
        const { userForm } = this.state;
        return Object.keys(userForm).length > 0;
    }

    render() {
        const steps = this.getSteps();
        return (
            <FHEContainer withBackIcon>
                <FHETitle title={Translator.translate('general.addHome')} Icon={SvgHome} />
                <FHEStepper sendFunc={this.saveHome} ref={this.stepper} steps={steps} nonLinear />
            </FHEContainer>
        );
    }
}

function mapStateToProps(state, props) {
    const { history } = props;
    const selectors = getSelectors(history.environment);
    return {
        profile: selectors.getProfile(state)
    };
}

export default withRouter(
    renderEnvComponent(
        'scenes/Home/add',
        connect(
            mapStateToProps,
            (dispatch, ownProps) => bindActionCreators(tools.mergePropsToAction(ownProps.history.environment, { addHome, emailExists }), dispatch)
        )(HomeAdd)
    )
);



// WEBPACK FOOTER //
// ./environments/genericEnv/scenes/Home/add.js